import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../../../../components/helpers/StatePresenter'
import { useEffect } from 'react'
import { useServiceOrderContextEvents } from '../../../../ServiceOrderContextEvents'

const Context = React.createContext([])
const { Provider } = Context
export const useEventsState = () => React.useContext(Context)
export const useEvents = () => useEventsState()?.events

const QUERY = gql`
  query Events($serviceOrderIds: [Int]) {
    events(filter: { serviceOrderIds: $serviceOrderIds }) {
      id
      eventDate
      status {
        id
        name
        color
      }
      reason {
        id
        name
      }
      description
      user {
        id
        name
      }
    }
  }
`

const EventsLoader = ({ children }) => {
  const { data: id } = useCurrentModal()
  const { setEvents } = useServiceOrderContextEvents()

  const { data, ...state } = useQuery(QUERY, {
    variables: { serviceOrderIds: [id] },
    client: serviceOrdersClient
  })

  useEffect(() => {
    setEvents(data?.events)
  }, [data, setEvents])

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default EventsLoader
